module.exports = __webpack_public_path__ + "employees-21b62107/video-c942510ba422e55ebbc79788086e1b55.svg";